import * as Sentry from '@sentry/nextjs';
import { EventApi } from '@fullcalendar/common';
import { DateTime } from 'luxon';

const adjustForTimezoneMeetingForm = (
  clickedEvent: EventApi | undefined,
  date: Date | undefined,
  timeZoneId?: string
): Date => {
  try {
    if (!date) throw 'Date cannot be null';

    if (timeZoneId) {
      // Create a DateTime in the specified timezone, then convert to UTC
      const localDateTime = DateTime.fromJSDate(date, { zone: 'UTC' });
      const timezoneDateTime = localDateTime.setZone(timeZoneId, {
        keepLocalTime: true,
      });
      const utcDateTime = timezoneDateTime.toUTC();
      return utcDateTime.toJSDate();
    } else {
      const timeOffsetInMS: number = date.getTimezoneOffset() * 60000;
      date.setTime(date.getTime() + timeOffsetInMS);
      return date;
    }
  } catch (error) {
    Sentry.captureException(error);
    return new Date();
  }
};

export default adjustForTimezoneMeetingForm;
